namespace Matrix.Data {

    export interface ModelTargetPickerOptions  {
        modelCode: string;
        single?: boolean;
    }

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.flexify()
    export class ModelTargetPickerDialog extends Serenity.TemplatedDialog<ModelTargetPickerOptions> {

        private pickerGrid: ModelTargetPickerGrid;

        constructor(opt: ModelTargetPickerOptions) {
            super(opt);

            this.pickerGrid = new ModelTargetPickerGrid(this.byId("PickerGrid"), opt);
            this.pickerGrid.element.flexHeightOnly();
            this.dialogTitle = "Select Targets";
        }

        protected getTemplate() {
            return `<div id="~_PickerGrid"></div>`;
        }

        protected getDialogOptions() {
            var opt = super.getDialogOptions();
            opt.buttons = [
                {
                    text: Q.text("Dialogs.OkButton"),
                    click: () => {
                        var selected = this.pickerGrid.selectedItems;
                        if (!selected.length) {
                            Q.notifyWarning("Please select some targets");
                            return;
                        }

                        if (this.options.single && selected.length > 1) {
                            Q.notifyWarning("Please select a single target");
                            return;
                        }

                        if (!this.onSuccess || this.onSuccess(selected))
                            this.dialogClose();
                    }
                },
                {
                    text: Q.text("Dialogs.CancelButton"),
                    click: () => {
                        this.dialogClose();
                    }
                }
            ];
            return opt;
        }

        get selectedItems() {
            return this.pickerGrid.selectedItems;
        }

        get value() {
            return this.pickerGrid.value;
        }

        set value(value: string[]) {
            this.pickerGrid.value = value;
        }

        set criteria(value: any[]) {
            this.pickerGrid.criteria = value;
        }

        public onSuccess: (selected: ModelTargetRow[]) => boolean;
    }
}